import { chakra } from '@chakra-ui/react/styled-system';
import { useId } from 'react';

type UpsellBackgroundProps = {
  /** `none` stretches the glow to the box; `xMidYMid slice` scales it uniformly and crops. */
  preserveAspectRatio?: 'none' | 'xMidYMid slice';
};

const UpsellBackground = ({ preserveAspectRatio = 'none' }: UpsellBackgroundProps) => {
  const instanceId = useId();

  return (
    <chakra.svg
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      preserveAspectRatio={preserveAspectRatio}
      viewBox="0 0 640 716"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g filter={`url(#blur-${instanceId}-0)`}>
        <circle cx="320.113" cy="358" r="506" fill={`url(#glow-${instanceId}-0)`} />
      </g>
      <g filter={`url(#blur-${instanceId}-1)`}>
        <circle cx="320.681" cy="358.568" r="405.897" fill={`url(#glow-${instanceId}-1)`} />
      </g>
      <g filter={`url(#blur-${instanceId}-2)`}>
        <circle cx="320.302" cy="358.189" r="287.44" fill={`url(#glow-${instanceId}-2)`} />
      </g>
      <g filter={`url(#blur-${instanceId}-3)`}>
        <circle cx="320.492" cy="358.378" r="179.39" fill={`url(#glow-${instanceId}-3)`} />
      </g>
      <defs>
        <filter
          id={`blur-${instanceId}-0`}
          x="-191.564"
          y="-153.677"
          width="1023.35"
          height="1023.35"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.83844" />
        </filter>
        <filter
          id={`blur-${instanceId}-1`}
          x="-90.8934"
          y="-53.0067"
          width="823.148"
          height="823.148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.83844" />
        </filter>
        <filter
          id={`blur-${instanceId}-2`}
          x="27.1858"
          y="65.0727"
          width="586.233"
          height="586.233"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.83844" />
        </filter>
        <filter
          id={`blur-${instanceId}-3`}
          x="135.425"
          y="173.312"
          width="370.133"
          height="370.133"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.83844" />
        </filter>
        <radialGradient
          id={`glow-${instanceId}-0`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(320.113 358) rotate(90) scale(506)"
        >
          <stop stopColor="#DEB4FF" />
          <stop offset="1" stopColor="#F6EAFF" />
        </radialGradient>
        <radialGradient
          id={`glow-${instanceId}-1`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(320.681 358.568) rotate(90) scale(405.897)"
        >
          <stop stopColor="#DEB4FF" />
          <stop offset="1" stopColor="#F6EAFF" />
        </radialGradient>
        <radialGradient
          id={`glow-${instanceId}-2`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(320.302 358.189) rotate(90) scale(287.44)"
        >
          <stop stopColor="#DEB4FF" />
          <stop offset="1" stopColor="#F6EAFF" />
        </radialGradient>
        <radialGradient
          id={`glow-${instanceId}-3`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(320.492 358.378) rotate(90) scale(179.39)"
        >
          <stop stopColor="#DEB4FF" />
          <stop offset="1" stopColor="#F6EAFF" />
        </radialGradient>
      </defs>
    </chakra.svg>
  );
};

export default UpsellBackground;
